import { render, staticRenderFns } from "./itemA.vue?vue&type=template&id=f4136cfe&scoped=true&"
import script from "./itemA.vue?vue&type=script&lang=js&"
export * from "./itemA.vue?vue&type=script&lang=js&"
import style0 from "./itemA.vue?vue&type=style&index=0&id=f4136cfe&lang=scss&scoped=true&"
import style1 from "./itemA.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4136cfe",
  null
  
)

export default component.exports